import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {Entity} from '../models/entity.model';
@Injectable({
  providedIn: 'root'
})
export class EntityService {

  constructor(private http: HttpClient) { }
  getEntity(): Observable<any> {
  return this.http.get<any>(`${environment.url}/entity`);
  }
  saveEntity(entity: Entity) {
    return this.http.post<any>(`${environment.url}/entity`, entity);
  }
  getEntityById(idA: number) {
    return this.http.get(`${environment.url}/entity/` + idA);
  }

  updateEntity(entity: Entity) {
    return this.http.put<any>(`${environment.url}/entity/` + entity.id, entity);
  }
  deleteEntity(idA: number) {
    return this.http.delete(`${environment.url}/entity/` + idA);
  }
}
